import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Person extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get firstName() {
    return get(this, '_imie.value', '');
  }

  get lastName() {
    return get(this, '_nazwisko.value', '');
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get position() {
    return get(this, '_stanowisko.value', '');
  }

  get photo() {
    return get(this, '_zdjecie.value[0].url', '');
  }

  get phoneNumber() {
    return get(this, '_numer_telefonu.value', '');
  }

  get email() {
    return get(this, '_adres_email.value', '');
  }

  get description() {
    return get(this, '_opis.value', '');
  }

  get facebookLink() {
    return get(this, '_link_facebook.value', '');
  }

  get linkedInLink() {
    return get(this, '_link_linkedin.value', '');
  }

  get skypeLink() {
    return get(this, '_link_skype.value', '');
  }

  get upworkLink() {
    return get(this, '_link_upwork.value', '');
  }

  get pdfLink() {
    return get(this, '_link_pdf.value', '');
  }

  get positionType() {
    return get(this, '_typ_stanowiska.value', '');
  }

  get professionalAchievements() {
    return get(this, '_osiagniecia_zawodowe.value', '');
  }

  get codeName() {
    return get(this, 'system.codename');
  }
}



// WEBPACK FOOTER //
// ./src/models/Person.js